/* eslint-disable */
export default {
  eula: 'End User Licence Agreement',
  eulaAbbr: 'EULA',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
